import { useState } from 'react';

export function useEditableQuestionSetFields(
  initialValue, 
  patchEndpoint, 
  fieldName, 
  infoQuestionSetId, 
  axiosInstance, 
  setInfoQuestionSet
) {
  
  const [isSaving, setIsSaving] = useState(false);
  const [isSaved, setIsSaved] = useState(true);
  const [isError, setIsError] = useState(false);

  const handleChange = (e) => {
    setIsSaved(false);
    setIsError(false);
    setInfoQuestionSet((prev) => ({
      ...prev,
      [fieldName]: e.target.value
    }));
  };

  const handleSave = async (value) => {
    console.log('value:', value);
    const trimmed = value.trim();
    if (!trimmed.length) return;

    setIsError(false);
    setIsSaving(true);
    try {
      const response = await axiosInstance.patch(
        `/knovia/infoQuestionSet/${infoQuestionSetId}/${patchEndpoint}`,
        { [fieldName]: trimmed }
      );
      setInfoQuestionSet((prev) => ({
        ...prev,
        ...response.data
      }));
      setIsSaved(true);
    } catch (err) {
      setIsError(true);
      console.error(err);
    } finally {
      setIsSaving(false);
    }
  };

  return {
    isSaving,
    isSaved,
    isError,
    handleChange,
    handleSave,
  };
}
